import { render } from "./submissions-panel.vue?vue&type=template&id=250cda70&scoped=true&ts=true"
import script from "./submissions-panel.vue?vue&type=script&lang=ts"
export * from "./submissions-panel.vue?vue&type=script&lang=ts"

import "./submissions-panel.vue?vue&type=style&index=0&id=250cda70&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250cda70"]])

export default __exports__